export const FOOTER_PARAGRAPH = "Blood Donors Across Pakistan is the pioneer in voluntary healthy blood donation services all over Pakistan with the aim of supporting the people through blood donations & more."
export const FOOTER_EMAIL_LINK = '+92 305 429-9990' //'info@bdap.pk'
export const ABOUT_US ='ABOUT US'
export const DONORS ='DONORS'
export const BLOOD_REQUESTS ='BLOOD REQUESTS'
export const CONTACT ='CONTACT'
export const JOIN_US ='JOIN US'
export const OUR_PROJECTS ='OUR PROJECTS'
